import { Controller, useFormContext } from 'react-hook-form';
import css from './index.module.scss';
import { BoxContainer, TextField } from '@components/common';
import { Typography } from '@components/base';
import { customerOrderInformation } from '@pages/order/generate-bill-of-lading/bol';

interface ICustomerOrderInformation {
  data: customerOrderInformation | null;
}

const CustomerOrderInformation = (props: ICustomerOrderInformation) => {
  const { control } = useFormContext();
  const { data } = props;
  return (
    <BoxContainer className={css.mainWrapper} title="Customer Order Information">
      <div className={css.boxWrapper}>
        <div className={css.rowWrapper}>
          <TextField
            name="customerOrderNumber"
            label="Customer PO Number"
            disabled
            value={data?.customerPoNumber}
            placeholder="Enter Customer PO Number"
            rootClassName={css.fieldWrapper}
          />
          <TextField
            name="totalNoOfPackages"
            label="No. of Packages"
            disabled
            value={data?.totalPackages}
            placeholder="Enter No. of Packages"
            rootClassName={css.fieldWrapper}
          />
          <TextField
            name="totalWeight"
            label={
              <div>
                Total Weight ({' '}
                <span>
                  <Typography variant="label">in {data?.unitOfWeight}</Typography>
                </span>{' '}
                )
              </div>
            }
            disabled
            value={data?.totalWeight}
            placeholder="Enter Total Weight"
            rootClassName={css.fieldWrapper}
          />
        </div>
        <div className={css.rowWrapper}>
          <Controller
            name="additionalNotes"
            control={control}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                label="Additional Notes"
                placeholder="Enter any additional notes"
                error={fieldState.invalid}
                helperText={fieldState.error?.message}
                rootClassName={css.fieldWrapper}
              />
            )}
          />
        </div>
      </div>
    </BoxContainer>
  );
};

export default CustomerOrderInformation;
